import { render, staticRenderFns } from "./ead-cursos.vue?vue&type=template&id=787ed3e6&scoped=true&"
import script from "./ead-cursos.vue?vue&type=script&lang=js&"
export * from "./ead-cursos.vue?vue&type=script&lang=js&"
import style0 from "./ead-cursos.vue?vue&type=style&index=0&id=787ed3e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ed3e6",
  null
  
)

export default component.exports